import clsx from 'clsx'

export function Divider({ soft = false, className, ...props }) {
  return <hr {...props} className={clsx('w-full border-t', soft ? 'border-zinc-950/5' : 'border-zinc-200', className)} />
}

export function VerticalDivider({ className, ...props }) {
  return <div {...props} className={clsx('h-full w-px bg-zinc-200', className)} />
}
